<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          small
          dark
          v-bind="attrs"
          v-on="on"
          bottom
          right
          class="float-right mx-4"
          color="blue-grey"
          style="position: relative; margin-top: -60px"
          @click="backPage"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </template>
      <span>Voltar</span>
    </v-tooltip>
    <v-card elevation="0">
      <v-row v-for="cat in getCategoryInCache" :key="cat">
        <v-col
          class="mt-n3 mb-n3"
          v-for="product in cat.productCategoryEntits"
          :key="product"
          v-show="product.productCategoryID === $route.params.syID"
        >
          <v-row>
            <v-col
              cols="12"
              xs="12"
              sm="12"
              md="6"
              lg="3"
              v-for="(listProduct, ind) in product.productsCategory.products"
              :key="listProduct"
            >
              <v-card :id="`sys${ind}`"
                class="mx-2"
                style="box-shadow: 0 4px 1px -3px #0000000d, 0 0 0 0 #00000000, 0 1px 5px 0 #00000008; background-color: #f6f6f6"
              >
                <div>
                  <v-row>
                    <v-col class="mx-4">
                      <div
                        class="text-uppercase text-card-title"
                        :id="`nm${ind}`"
                      >
                        {{ listProduct.productName }}
                        <!--                    {{ $route.params.syID }}-->
                      </div>
                      <div class="blue-grey--text" :id="`np${ind}`">
                        {{ listProduct.productPrice }} AKZ
                      </div>
<!--                      <div class="text-card-category">-->
<!--                        <v-icon size="12">mdi-view-list</v-icon>-->
<!--                      </div>-->
                    </v-col>
                    <v-col class="mx-3 bg-card-sugest text-right">
                      <div>
                        <span>
                          <v-btn
                            fab
                            dark
                            text
                            small
                            color="indigo"
                            class="mx-2"
                            @click="
                              edit(
                                listProduct.productUUID,
                                $route.params.syID,
                                listProduct.productName,
                                listProduct.productPrice,
                                ind
                              )
                            "
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </span>
                        <span>
                          <v-btn
                            fab
                            dark
                            text
                            small
                            color="error"
                            class="mx-2"
                            @click="deleteProduct(listProduct.productUUID, ind)"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import eventBus from "../../../../main";
import { mapHelperEnterprise } from "@/store/helperEnterprise";
export default {
  name: "ProductComponent",
  data: () => ({}),
  methods: {
    edit(index, cat, name, price, ind) {
      const value = {
        dialog: true,
        index: index,
        cat: cat,
        name: name,
        price: price,
        ind: ind
      };
      eventBus.$emit("openEditProduct", value);
    },
    deleteProduct(index, ind) {
      const value = {
        dialog: true,
        index: index,
        obj: ind
      };
      eventBus.$emit("openDeleteProduct", value);
    },
    addProduct() {
      eventBus.$emit("openAddProduct", true);
    },
    backPage() {
      // eventBus.$emit("openAddProduct", true);
      // this.$router.go(-1);
      this.$router.push("/product/category");
    }
  },
  computed: {
    ...mapHelperEnterprise
  },
  created() {
    eventBus.$on("updateRealtimeProduct", function(value) {
      let nmb = value.nmb;
      let cp = "nm" + nmb;
      let np = "np" + nmb;
      let metaN = document.getElementById(cp);
      let metaP = document.getElementById(np);
      metaN.innerHTML = "";
      metaN.innerHTML = value.productName;
      metaP.innerHTML = value.productPrice + " AKZ";
    });
  }
};
</script>

<style scoped>
.text-card-title {
  color: #8898aa !important;
  font-size: 12px;
}
.text-card-category {
  /*color: #560707 !important;*/
  color: #35775b !important;
  font-size: 11px;
  /*background: linear-gradient(87deg, #fb6340, #fbb140) !important;*/
}
.bg-card-sugest {
  background: linear-gradient(87deg, #9c2a2a00, #26a69a24) !important;
  /*background: linear-gradient(87deg, #9c2a2a00, #1976d259) !important;*/
  /*background: linear-gradient(87deg, #9c2a2a00, #8dfb4078) !important;*/
}
</style>
